import type { PageExperienceFragment } from '@/features/experiences/fragments/PageExperience.generated';
import { getPublishedLink } from '@/features/experiences/lib/publish';
import { Flex, Icon, IconButton, Input, InputGroup } from '@/ui';
import { CopyLinkButton } from '../CopyLinkButton';

type ReadOnlyLinkProps = {
  experience: PageExperienceFragment;
};

export const ReadOnlyLink = ({ experience }: ReadOnlyLinkProps) => {
  if (!experience) {
    return null;
  }

  const link = getPublishedLink(experience);

  return (
    <Flex>
      <InputGroup>
        <Input
          bg="customgray.bglight"
          readOnly
          value={link ?? ''}
          onClick={(event) => event.currentTarget.select()}
        />
      </InputGroup>
      <Flex align="center" borderRadius="md" gap="1" px="1">
        <IconButton
          aria-label="Open in new tab"
          as="a"
          bg="gray.200"
          color="currentColor"
          colorScheme="blackAlpha"
          href={link ?? undefined}
          icon={<Icon icon="ArrowUpRight" />}
          size="md"
          target="_blank"
          _hover={{
            bg: 'gray.300',
          }}
        />

        <CopyLinkButton experience={experience} />
      </Flex>
    </Flex>
  );
};
